import { render, staticRenderFns } from "./management_new.vue?vue&type=template&id=10584368&scoped=true"
import script from "./management_new.vue?vue&type=script&lang=js"
export * from "./management_new.vue?vue&type=script&lang=js"
import style0 from "./management_new.vue?vue&type=style&index=0&id=10584368&prod&lang=less&scoped=true"
import style1 from "./management_new.vue?vue&type=style&index=1&id=10584368&prod&lang=less"
import style2 from "./management_new.vue?vue&type=style&index=2&id=10584368&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10584368",
  null
  
)

export default component.exports